angular.module('aprima-provider-api').factory('DrugRepository',
    ['$q', '_', 'AprimaRestangular', 'AprimaAnalytics', 'CurrentUser', 'Guid', 'ServerInfoRepository', 'SettingRepository',
        function ($q, _, AprimaRestangular, AprimaAnalytics, CurrentUser, Guid, ServerInfoRepository, SettingRepository) {
            'use strict';

            return {
                search: drugSearch,
                getPatientActiveDrugs: getPatientActiveDrugs,
                getMfuDrugs: getMfuDrugs,
                drugDosageAlternativesSearch: drugDosageAlternativesSearch,
                drugScreening: drugScreening,
                getDrugDocumentation: getDrugDocumentation,
                getDrugDosingSuggestions: getDrugDosingSuggestions,
                getDrugFormularyInfo: getDrugFormularyInfo,
                getDrugRepresentativeFormularies: getDrugRepresentativeFormularies,
                getDrugFormularyDetail: getDrugFormularyDetail,
                getDrugDetail: getDrugDetail,
                getKdbConfigurationId: getKdbConfigurationId,
                nddDrugScreening: nddDrugScreening,
                nddDrugScreeningMobile: nddDrugScreeningMobile,
            };

            function drugDosageAlternativesSearch(drug, providerId, kdbConfigurationId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'search drug dosage alternatives');

                var restangular = AprimaRestangular.get(restangularOptions);

                var promise = restangular.one('drugs/dosagealternatives')
                                         .customPOST({
                                            Drug: drug,
                                            ProviderId: providerId || null,
                                            KdbConfigurationId: kdbConfigurationId || null,
                                         })
                                        .then(function(list) {
                                            var standardizedList = handleObsoleteProperty(list);
                                            return standardizedList;
                                        });
                                
                promise.finally(timing.stop);
                return promise;                
            }

            function drugSearch(searchText, patientId, previousSearch, includeNonDispensable, kdbConfigurationId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'search drugs');

                var providerId = CurrentUser.get().userId;

                var restangular = AprimaRestangular.get(restangularOptions);
                var includeInactive = false, includeObsolete = false;
                var words = _.words(searchText, /[^ ]+/g);
                var inactiveTerms = [], obsoleteTerms = [];
                inactiveTerms = _.filter(words, function(s) { return s && s.toUpperCase() === 'INACTIVE'; });
                obsoleteTerms = _.filter(words, function(s) { return s && s.toUpperCase() === 'OBSOLETE'; });
                if(inactiveTerms.length > 0) {
                    includeInactive = true;
                    words = _.difference(words, inactiveTerms);
                }
                if(obsoleteTerms.length > 0) {
                    includeObsolete = true;
                    words = _.difference(words, obsoleteTerms);
                }
                searchText = words.join(' ');

                var endpoint = includeNonDispensable ? 'drug-history-drugs' : 'drugs';

                var promise = restangular.all(endpoint).abortable(previousSearch)
                        .getList({
                            SearchText: searchText,
                            PatientId: patientId,
                            ProviderId: providerId,
                            IncludeInactive: includeInactive,
                            IncludeObsolete: includeObsolete,
                            KdbConfigurationId: kdbConfigurationId,
                        })
                        .then(function(list) {
                            var standardizedList = handleObsoleteProperty(list);
                            return standardizedList;
                        });

                promise.finally(timing.stop);
                return promise;
            }

            // IsInactiveOrObsolete was moved from DrugResultDto to a property inside of DrugDto
            // this standardizes the data structure so it looks the same whether the server has this change or not
            function handleObsoleteProperty(drugSearchList) {
                if(!drugSearchList || !_.isArray(drugSearchList)) {
                    return drugSearchList;
                }

                _.forEach(drugSearchList, function(drugResult) {
                    var drug = drugResult && drugResult.Drug;
                    if(drug && !_.has(drug, 'IsInactiveOrObsolete')) {
                        drug.IsInactiveOrObsolete = !!drugResult.IsInactiveOrObsolete;
                    }
                });
                return drugSearchList;
            }

            function getPatientActiveDrugs(patientId, kdbConfigurationId, restangularOptions) {
                var providerId = CurrentUser.get().userId;

                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'search drugs');
                var restangular = AprimaRestangular.get(restangularOptions);
                var promise = restangular
                    .all('drugs/patientactivedrugs/' + patientId)
                    .abortable()
                    .getList({
                        providerId: providerId,
                        kdbConfigurationId: kdbConfigurationId,
                    });
                promise.finally(timing.stop);
                return promise;
            }

            function getMfuDrugs(restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'search drugs');
                var restangular = AprimaRestangular.get(restangularOptions);
                var promise = restangular.all('drugs/mostfrequentlyused/' + CurrentUser.get().userId).abortable().getList();
                promise.finally(timing.stop);
                return promise;
            }

            function drugScreening(patientId, medId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'search drugs');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.one('drugs/' + medId + '/screening/' + patientId).get().finally(timing.stop);
            }
            
            function nddDrugScreeningMobile(patientId, medId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'ndd search drugs');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.one('drugs/' + medId + '/nddscreening/' + patientId).get().finally(timing.stop);
            }

            function getDrugDosingSuggestions(patientId, medId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'dosing suggestions');
                var restangular = AprimaRestangular.get(restangularOptions);

                // to be backwards compatible, have to pass a guid for the patientId
                // because in older versions it was not nullable
                var patientIdOrGuidEmpty = patientId || Guid.empty();

                var promise = restangular
                    .one('drugs', medId)
                    .one('dosing', patientIdOrGuidEmpty)
                    .get()
                    .finally(timing.stop);
                return promise;
            }

            function getDrugDocumentation(medId, ndc, patientId, mode, restangularOptions) {
                if(!ServerInfoRepository.isFeatureSupported('DrugDocumentationV2')) {
                    // call older endpoint
                    var oldResult = getDrugDocumentationV1(medId, ndc, patientId, mode, restangularOptions);

                    return oldResult;
                }


                // call newer endpoint
                var newResult = getDrugDocumentationV2(medId, ndc, patientId, mode, restangularOptions);

                return newResult;
            }

            function getDrugDocumentationV1(medId, ndc, patientId, mode, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};

                var routeNdc = ndc || 0;

                // passing these values as query string parameters will override the ones in the route in webapi, but they still have to be passed 
                // in the route to match the endpoint template
                var params = {
                    // if there is no ndc, then to match the route,
                    // it needs to be medId/0
                    // but the query param needs to be empty string, so that the url has ?ndc=
                    // and the backend will interpret that as null
                    NDC: routeNdc || '',
                    
                    // MedId is int on backend, so don't let it be null, undefined, etc.
                    MedId: medId || 0,
                    
                    // PatientId is non-nullable guid on backend, so make sure it's not passed as null
                    PatientId: patientId || Guid.empty(),
                };

                if(mode) {
                    params.BriefMode = mode;
                }

                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug documentation');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular
                    .one('drugs/' + params.MedId + '/' + routeNdc + '/documentation/' + params.PatientId)
                    .get(params)
                    .finally(timing.stop);
            }

            function getDrugDocumentationV2(medId, ndc, patientId, mode, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};

                var params = {
                    // for new endpoint ndc can be passed as null here
                    NDC: ndc || null,
                    
                    // for new endpoint, MedId is nullable
                    MedId: medId || null,
                    
                    // for new endpoint, PatientId is nullable
                    PatientId: patientId || null,
                };

                if(mode) {
                    params.BriefMode = mode;
                }

                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug documentation');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular
                    .one('drug-documentation')
                    .get(params)
                    .finally(timing.stop);
            }
            
            // This endpoint should not be called starting in PRM2018.
            function getDrugFormularyInfo(medId, patientId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug formulary info');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.all('drugs/' + medId + '/formularyalternatives/' + patientId)
                                  .getList()
                                  .finally(timing.stop);
            }
            
            function getDrugRepresentativeFormularies(medId, eRxEligibilityId, patientId, relVisitMedicationId, pharmacyId, days, dispenseAsWritten, totalQuantity, unitOfMeasureId, previousPMBCParameters, previousRFSParameters, providerId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'get drug representative formularies');
                var restangular = AprimaRestangular.get(restangularOptions);
                var url = 'drugs/' + medId +
                          '/representativeformularies/' + (eRxEligibilityId || Guid.empty()) +
                          '?days=' + (days || '') +
                          '&dispenseAsWritten=' + (dispenseAsWritten || '') +
                          '&proposedRelVisitMedicationId=' + (relVisitMedicationId || '') +
                          '&patientId=' + (patientId || '') +
                          '&pharmacyId=' + (pharmacyId || Guid.empty()) +
                          '&totalQuantity=' + (totalQuantity || '') +
                          '&unitOfMeasureId=' + (unitOfMeasureId || '') +
                          '&previousPMBCParameters=' + (previousPMBCParameters ? encodeURIComponent(previousPMBCParameters) : '') +
                          '&previousRFSParameters=' + (previousRFSParameters ? encodeURIComponent(previousRFSParameters) : '') +
                          '&providerId=' + (providerId || Guid.empty());
                return restangular.one(url)
                                  .get()
                                  .finally(timing.stop);
            }
            
            function getDrugFormularyDetail(medId, patientId, restangularOptions){
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming();
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.all('drugs/' + medId + '/formularydetail/' + patientId).getList().finally(timing.stop);
            }

            function getDrugDetail(medId, patientId, relPatientMedicationId, sigId, restangularOptions){
                restangularOptions = restangularOptions || {ignoreCache: false};
                
                var timing = AprimaAnalytics.startTiming();
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.one('drugs/' + medId + '/drugdetail/' + patientId).get({relPatientMedicationId: relPatientMedicationId, sigId: sigId}).finally(timing.stop);
            }

            function nddDrugScreening(patientId, drug, otherDrugs, previousMedicationSigId) {
                var timing = AprimaAnalytics.startTiming('DrugRepository', 'api', 'nddDrugScreening');
                var restangular = AprimaRestangular.get();
                return restangular.one('patients/' + patientId + '/nddscreening')
                                  .customPOST({
                                      Drug: drug,
                                      OtherDrugs: otherDrugs,
                                      PreviousMedicationSigUid: previousMedicationSigId
                                  })
                                  .finally(timing.stop);

            }

            // !userId means just use the CurrentUser
            function getKdbConfigurationId(userId, renderingProviderId, billingProviderId) {
                var promise = SettingRepository.getKdbConfigurationId(userId, renderingProviderId, billingProviderId);
                return promise;
            }
        }]);